import { jsx as n } from "react/jsx-runtime";
import { tv as l } from "../tailwind-variants.config.js";
const d = l({
  slots: {
    container: "jm-flex jm-items-center jm-justify-center jm-bg-jutro-new-rose-200",
    photo: "jm-object-cover jm-h-full jm-w-full jm-rounded-[inherit]",
    initials: "jm-leading-[100%] jm-font-semibold jm-uppercase",
    icon: "jm-flex jm-items-center jm-justify-center"
  },
  variants: {
    size: {
      "3xl": {
        container: "jm-h-32 jm-w-32 jm-rounded-3xl",
        initials: "jm-font-display-1",
        icon: "[&>svg]:jm-h-[72px] [&>svg]:jm-w-[72px]"
      },
      "2xl": {
        container: "jm-h-24 jm-w-24 jm-rounded-2xl",
        initials: "jm-font-display-2",
        icon: "[&>svg]:jm-h-14 [&>svg]:jm-w-14"
      },
      xl: {
        container: "jm-h-16 jm-w-16 jm-rounded-xl",
        initials: "jm-font-heading-1",
        icon: "[&>svg]:jm-h-10 [&>svg]:jm-w-10"
      },
      lg: {
        container: "jm-h-12 jm-w-12 jm-rounded-lg",
        initials: "jm-font-heading-3",
        icon: "[&>svg]:jm-h-8 [&>svg]:jm-w-8"
      },
      md: {
        container: "jm-h-8 jm-w-8 jm-rounded-md",
        initials: "jm-font-caption",
        icon: "[&>svg]:jm-h-6 [&>svg]:jm-w-6"
      },
      sm: {
        container: "jm-h-6 jm-w-6 jm-rounded-md",
        initials: "jm-font-geologica jm-text-[9px]",
        icon: "[&>svg]:jm-h-4 [&>svg]:jm-w-4"
      },
      xs: {
        container: "jm-h-4 jm-w-4 jm-rounded-sm",
        initials: "jm-font-geologica jm-text-[9px]",
        icon: "[&>svg]:jm-h-3 [&>svg]:jm-w-3"
      }
    },
    theme: {
      light: { container: "jm-text-jutro-new-warm-gray-800" },
      dark: { container: "jm-text-white" }
    }
  },
  defaultVariants: {
    size: "sm",
    theme: "light"
  }
}), v = (i) => {
  const t = i.size, m = "theme" in i ? i.theme : void 0, { container: e, photo: j, initials: o, icon: s } = d({ size: t, theme: m }), a = () => {
    const c = "imgSrc" in i, r = "initials" in i;
    return c ? /* @__PURE__ */ n("img", { className: j(), src: i.imgSrc, alt: "Awatar użytkownika" }) : r ? /* @__PURE__ */ n("span", { className: o(), children: i.initials }) : /* @__PURE__ */ n("div", { className: s(), children: i.icon });
  };
  return /* @__PURE__ */ n("div", { className: e(), children: /* @__PURE__ */ n(a, {}) });
};
export {
  v as Avatar
};
//# sourceMappingURL=index.js.map
